import { render, staticRenderFns } from "./PerfilUsuario.vue?vue&type=template&id=8d05902a&scoped=true&"
import script from "./PerfilUsuario.vue?vue&type=script&lang=js&"
export * from "./PerfilUsuario.vue?vue&type=script&lang=js&"
import style0 from "./PerfilUsuario.vue?vue&type=style&index=0&id=8d05902a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d05902a",
  null
  
)

export default component.exports